module.exports = __webpack_public_path__ + "img/ECA.d8762b4f.svg";